/**
 * .url 的兩種寫法：
 * - 第一行以 https:// 開頭：只開這一行，不讀後面的內容。
 * - 第一行是 [InternetShortcut]：讀第二行 URL= 之後的網址（Windows 網際網路捷徑）。
 */
const MAX_LINE = 2048;

const fail = (status, message) => Object.assign(new Error(message), { status });

/** Windows 捷徑有時是 UTF-16 LE。有 BOM 時先轉成文字，其餘依 UTF-8。 */
export function decodeUrlFile(buf) {
  const bytes = Buffer.isBuffer(buf) ? buf : Buffer.from(buf);
  if (bytes.length >= 2 && bytes[0] === 0xFF && bytes[1] === 0xFE) return bytes.subarray(2).toString('utf16le');
  return bytes.toString('utf8');
}

function normalize(value, invalidMessage) {
  if (!value || value.length > MAX_LINE) throw fail(422, invalidMessage);
  let url;
  try { url = new URL(value); } catch { throw fail(422, invalidMessage); }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') throw fail(422, '只接受 http 或 https 網址');
  if (url.username || url.password) throw fail(422, '網址不可包含帳號或密碼');
  return url.href;
}

export function parseUrlLink(text, { truncated = false } = {}) {
  const lines = String(text ?? '').replace(/^\uFEFF/, '').split(/\r?\n/);
  const first = (lines[0] ?? '').trim();
  if (/^https:\/\//i.test(first)) {
    if (truncated && lines.length === 1) throw fail(422, '第一行不是完整的 https 網址');
    return normalize(first, '第一行不是有效的 https 網址');
  }
  if (first === '[InternetShortcut]') {
    if (lines.length < 2 || (truncated && lines.length === 2)) throw fail(422, 'InternetShortcut 的第二行必須包含 URL=');
    const second = lines[1];
    const at = second.indexOf('URL=');
    if (at < 0) throw fail(422, 'InternetShortcut 的第二行必須包含 URL=');
    return normalize(second.slice(at + 4).trim(), 'URL= 之後不是有效的網址');
  }
  throw fail(422, '第一行必須是 https 網址，或 [InternetShortcut]');
}

/** 狀態列顯示用，不帶帳號資訊。 */
export function displayUrl(href) {
  const url = new URL(href);
  url.username = '';
  url.password = '';
  return url.href;
}
